import { ILaya } from "../../ILaya";
import { Matrix } from "../maths/Matrix";
import { Point } from "../maths/Point";
import { Rectangle } from "../maths/Rectangle";
import { PAL } from "../platform/PlatformAdapters";
export class SpriteUtils {
    static getGlobalRecByPoints(sprite, x0, y0, x1, y1, out) {
        let newLTPoint;
        newLTPoint = Point.create().setTo(x0, y0);
        newLTPoint = sprite.localToGlobal(newLTPoint);
        let newRBPoint;
        newRBPoint = Point.create().setTo(x1, y1);
        newRBPoint = sprite.localToGlobal(newRBPoint);
        let rst = Rectangle._getWrapRec([newLTPoint.x, newLTPoint.y, newRBPoint.x, newRBPoint.y], out);
        newLTPoint.recover();
        newRBPoint.recover();
        return rst;
    }
    static getGlobalPosAndScale(sprite) {
        let tmpRect = Rectangle.create();
        SpriteUtils.getGlobalRecByPoints(sprite, 0, 0, 1, 1, tmpRect);
        let ret = { x: tmpRect.x, y: tmpRect.y, scaleX: tmpRect.width, scaleY: tmpRect.height };
        tmpRect.recover();
        return ret;
    }
    static getTransformRelativeToWindow(coordinateSpace, x, y) {
        let stage = ILaya.stage;
        let globalTransform = SpriteUtils.getGlobalPosAndScale(coordinateSpace);
        let canvasMatrix = Matrix.create();
        stage._canvasTransform.copyTo(canvasMatrix);
        let canvasLeft = canvasMatrix.tx;
        let canvasTop = canvasMatrix.ty;
        canvasMatrix.rotate(-Math.PI / 180 * stage.canvasDegree);
        canvasMatrix.scale(stage.clientScaleX, stage.clientScaleY);
        let perpendicular = (stage.canvasDegree % 180 != 0);
        let tx, ty;
        if (perpendicular) {
            tx = y + globalTransform.y;
            ty = x + globalTransform.x;
            tx *= canvasMatrix.d;
            ty *= canvasMatrix.a;
            if (stage.canvasDegree == 90) {
                tx = canvasLeft - tx;
                ty += canvasTop;
            }
            else {
                tx += canvasLeft;
                ty = canvasTop - ty;
            }
        }
        else {
            tx = x + globalTransform.x;
            ty = y + globalTransform.y;
            tx *= canvasMatrix.a;
            ty *= canvasMatrix.d;
            tx += canvasLeft;
            ty += canvasTop;
        }
        let domScaleX, domScaleY;
        if (perpendicular) {
            domScaleX = canvasMatrix.d * globalTransform.scaleY;
            domScaleY = canvasMatrix.a * globalTransform.scaleX;
        }
        else {
            domScaleX = canvasMatrix.a * globalTransform.scaleX;
            domScaleY = canvasMatrix.d * globalTransform.scaleY;
        }
        canvasMatrix.recover();
        globalTransform.x = Math.round(tx);
        globalTransform.y = Math.round(ty);
        globalTransform.scaleX = Math.round(domScaleX * 100000) / 100000;
        globalTransform.scaleY = Math.round(domScaleY * 100000) / 100000;
        return globalTransform;
    }
    static fitDOMElementInArea(dom, coordinateSpace, x, y, width, height) {
        if (!dom._fitLayaAirInitialized) {
            dom._fitLayaAirInitialized = true;
            PAL.browser.setStyleTransformOrigin(dom.style, "left top");
            dom.style.position = "absolute";
        }
        let transform = SpriteUtils.getTransformRelativeToWindow(coordinateSpace, x, y);
        PAL.browser.setStyleTransform(dom.style, "scale(" + transform.scaleX + "," + transform.scaleY + ") rotate(" + (ILaya.stage.canvasDegree) + "deg)");
        dom.style.width = width + 'px';
        dom.style.height = height + 'px';
        dom.style.left = transform.x + 'px';
        dom.style.top = transform.y + 'px';
    }
    static localToGlobalRect(sp, rect, out) {
        out = out || Rectangle.create();
        let pt = sp.localToGlobal(Point.TEMP.setTo(rect.x, rect.y));
        let x = pt.x;
        let y = pt.y;
        sp.localToGlobal(pt.setTo(rect.right, rect.bottom));
        return out.setTo(x, y, x + pt.x, y + pt.y);
    }
    static globalToLocalRect(sp, rect, out) {
        out = out || Rectangle.create();
        let pt = sp.globalToLocal(Point.TEMP.setTo(rect.x, rect.y));
        let x = pt.x;
        let y = pt.y;
        sp.globalToLocal(pt.setTo(rect.right, rect.bottom));
        return out.setTo(x, y, x + pt.x, y + pt.y);
    }
    static transformRect(sp, rect, targetSpace, out) {
        targetSpace = targetSpace || ILaya.stage;
        tmpPoints.length = 0;
        rect.getBoundPoints(tmpPoints);
        if (targetSpace === sp._parent) {
            for (let i = 0, n = tmpPoints.length; i < n; i += 2) {
                let pt = sp.toParentPoint(Point.TEMP.setTo(tmpPoints[i], tmpPoints[i + 1]));
                tmpPoints[i] = pt.x;
                tmpPoints[i + 1] = pt.y;
            }
        }
        else {
            for (let i = 0, n = tmpPoints.length; i < n; i += 2) {
                let pt = sp.localToGlobal(Point.TEMP.setTo(tmpPoints[i], tmpPoints[i + 1]));
                targetSpace.globalToLocal(pt);
                tmpPoints[i] = pt.x;
                tmpPoints[i + 1] = pt.y;
            }
        }
        return Rectangle._getWrapRec(tmpPoints, out);
    }
    static getRect(sprite, sizeOnly, out) {
        out = out || Rectangle.create();
        if (sizeOnly == null || sizeOnly)
            out.setTo(0, 0, sprite.width, sprite.height);
        else
            sprite.getSelfBounds(out);
        out.x -= sprite.pivotX;
        out.y -= sprite.pivotY;
        if (sprite.scrollRect) {
            out.x -= sprite.scrollRect.x;
            out.y -= sprite.scrollRect.y;
        }
        out.x = Math.floor(out.x);
        out.y = Math.floor(out.y);
        out.width = Math.floor(out.width);
        out.height = Math.floor(out.height);
        if (out.width < 0)
            out.width = 0;
        if (out.height < 0)
            out.height = 0;
        return out;
    }
    static setRect(sprite, rect) {
        sprite.size(rect.width, rect.height);
        sprite.pos(rect.x + sprite.pivotX, rect.y + sprite.pivotY);
    }
    static getChildrenBounds(sprite, recursive, ignoreInvisibles, ignoreScale, out) {
        out = out || new Rectangle();
        out.setTo(0, 0, 0, 0);
        let children = recursive ? sprite._children : sprite._$children;
        for (let child of children) {
            if (ignoreInvisibles && !child._struct.enabled)
                continue;
            let w = child.width;
            let h = child.height;
            if (!ignoreScale) {
                w *= Math.abs(child._scaleX);
                h *= Math.abs(child._scaleY);
            }
            out.union(tmpRect.setTo(child._x - w * child._anchorX, child._y - h * child._anchorY, w, h), out);
            if (recursive && child._children.length > 0) {
                let rect = SpriteUtils.getChildrenBounds(child, recursive, ignoreInvisibles, ignoreScale);
                rect.x += child._x;
                rect.y += child._y;
                out.union(rect, out);
            }
        }
        return out;
    }
}
const tmpRect = new Rectangle();
const tmpPoints = [];
